import { render, staticRenderFns } from "./EditRecette.vue?vue&type=template&id=5c958baa&"
import script from "./EditRecette.vue?vue&type=script&lang=js&"
export * from "./EditRecette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports